import React from 'react';
import "../../../../styles/superAdmin/loadingSpinner.css"; 

const LoadingSpinner = () => {
  return (
    <div className="spinner"></div>
    
  );
};

export default LoadingSpinner;
